import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import { Add } from 'iconsax-react';
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from '../../../../components/Util/oders';

// Valori del filtro Stato, come compaiono nella lista.
const STATO_OPTIONS = ['Attivo', 'Completato', 'Sospeso', 'Invito in corso', 'Disattivo'];

// profileStatus → { label, variant } per il badge del design system
const STATUS_MAP = {
	ACTIVE: ['Attivo', 'success'],
	COMPLETED: ['Completato', 'success'],
	INACTIVE: ['Disattivo', 'muted'],
	SUSPENDED: ['Sospeso', 'warning'],
	INVITED: ['Invito in corso', 'warning'],
};

const fmtDate = (d) => {
	if (!d) return '-';
	const parts = String(d).split('-'); // yyyy-MM-dd
	if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
	return d;
};

export const JuniorTable = () => {
	const navigate = useNavigate();

	const openDetail = (row) => {
		navigate('/struttura/junior/junior_profile/' + row.id);
	};

	const [loadingShowed, setLoadingShowed] = useState(false);
	const [data_json, setDataJson] = useState(null);
	// Chip a scelta multipla: all'inizio tutti accesi
	const [statusFilter, setStatusFilter] = useState(STATO_OPTIONS);

	const data_column = [
		{
			Header: 'Nome e cognome',
			accessor: 'name',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
						alt={row.original.name}
						style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '10px', objectFit: 'cover', background: '#F1F2F4', flexShrink: 0 }}
					/>
					{row.original.name}
				</div>
			)
		},
		{
			Header: 'Player senior',
			accessor: 'parentName',
		},
		{
			Header: 'Data di nascita',
			accessor: 'birthdate',
		},
		{
			Header: 'Data di registrazione',
			accessor: 'dateregistration',
			sortType: dateTimeSort,
		},
		{
			Header: 'Stato',
			accessor: row => (row.status ? row.status.label : ''),
			Cell: ({ row }) => {
				const s = row.original.status;
				if (!s) return null;
				return <span className={`sid-badge sid-badge--${s.variant}`}>{s.label}</span>;
			},
			disableFilters: true,
		},
	];

	useEffect(() => {
		const fetchData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString) {
					const token = JSON.parse(tokenDetailsString).idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [customersData] = await Promise.all([apiClient.getJuniors(token)]);
					setLoadingShowed(false);

					const rows = [];
					if (customersData) {
						customersData.forEach(element => {
							const image = element.picture && element.picture.uri ? element.picture.uri : null;
							const [label, variant] = STATUS_MAP[element.profileStatus] || ['', 'muted'];

							const data = new Date(element.createdAt);
							const formattedDate = data.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' });

							rows.push({
								id: element.userId,
								name: `${element.givenName} ${element.familyName}`,
								imageUrl: image,
								parentName: element.parentName,
								birthdate: fmtDate(element.birthdate),
								dateregistration: formattedDate,
								status: label ? { label, variant } : null,
							});
						});
					}
					setDataJson(rows);
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();
	}, []);

	const filteredData = data_json
		// Uno stato mancante resta sempre visibile
		? data_json.filter((r) => !STATO_OPTIONS.includes(r.status?.label) || statusFilter.includes(r.status?.label))
		: data_json;

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
					<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<TabellaLista
				pageList={true}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				cardTitle={'Junior'}
				searchPlaceholder={'Cerca per nome o Player senior'}
				hasSearch={true}
				hasFilter={false}
				hasAddMore={false}
				headerButtons={
					<Link to="/struttura/junior/nuovo" className="btn btn-primary">
						<Add size={16} className="me-1" />Aggiungi Junior
					</Link>
				}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statusFilter} onChange={setStatusFilter} multiple />
					</div>
				}
				data_column={data_column}
				data_json={filteredData}
				sort_by={'dateregistration'}
				sort_type={'desc'}
			/>
		</>
	)
}
export default JuniorTable;
